import React, { useState } from 'react'
import { useTranslate } from './TranslationText';
import LazyLoadImage from './LazyLoadImage';
import CustomButton from './CustomButton';
import ImageViewer from './ImageViewer';
import { Link } from 'react-router-dom';

export default function Album({ item, }) {
    const MediaBaseURL = process.env.REACT_APP_BACKEND_API;
    const { translate } = useTranslate();
    const [index, setIndex] = useState(-1);

    const [images, setImages] = useState([]);
    const handleClick = (index, albumMedia) => {
        setImages(albumMedia.map((media) => ({ src: MediaBaseURL + media.url })));
        setIndex(index);
    };

    return (
        <>

            <div className="secondSectionContainer MediaGallerySectionContainer mb-3 p-3" style={{ borderRadius: 15 }}>
                <h3 className='text-start w-100 fw-bold mb-2' style={{textTransform:'uppercase'}}>{item?.albumName}</h3>
                <div className="mediaGalleryContainer rtl">
                    {item.albumMedia.map((image, imgIndex) => (
                        imgIndex < 7 &&
                        <LazyLoadImage
                            key={`${index}-${imgIndex}`}
                            image={image}
                            albumId={item.albumId}
                            albumName={item.albumName}
                            onClick={() => handleClick(imgIndex, item.albumMedia)}
                            counter={imgIndex}
                            index={imgIndex}
                            startDate={item.albumStartDate}
                            translate={translate}
                        />
                    ))}
                </div>
                <ImageViewer
                    index={index}
                    setIndex={setIndex}
                    images={images}
                />
                <div className="text-center ms-auto mt-3">
                    <Link
                        to={`/album-details?id=${item?.albumId}`}
                        className='btn w-unset btn-success  px-4 py-2 rounded-pill'
                    >
                        {translate(`web.viewAll`, 'View All')}
                    </Link>
                </div>
            </div>
        </>
    )
}
